import { StringField } from "../../../types/types";
import {
  PageTitleFields,
  PageTitleProps,
  PageTitle,
} from "../types/PageTitle.types";

export class PageTitleModel {
  private readonly fields?: PageTitleFields;

  constructor(props: PageTitleProps) {
    this.fields = props.fields;
  }

  get title(): StringField | undefined {
    return this.fields?.Title
  }
}
